import { useQuery, useMutation } from "@tanstack/react-query";
import DataService from "../../../helpers/config/DataService";
import { useCustomToaster } from "../../../hooks/useCustomToaster";

const { getRequest, postRequest } = DataService();

export const useGetProfile = () => {
  const token = localStorage.getItem("token");
  return useQuery({
    queryKey: ["profile"],
    queryFn: () => {
      return getRequest(`/profile`);
    },
    enabled: !!token,
  });
};

export const useGetRevenue = () => {
  const token = localStorage.getItem("token");
  return useQuery({
    queryKey: ["get_revenue"],
    queryFn: () => {
      return getRequest(`/get_revenue`);
    },
    enabled: !!token
  });
};

export const useNotification = () => {
  const toaster = useCustomToaster();
  return useMutation({
    mutationFn: (data) => {
      return postRequest(`/get_notifications`, { ...data });
    },
    onSuccess: (success) => {
      if (!success?.status) {
        toaster.error(success?.message);
      }
    },
    onError: () => {
      toaster.error("Something went wrong");
    },
  });
};

export const useGetNotificationCount = () => {
  const toaster = useCustomToaster();
  return useMutation({
    mutationFn: (data) => {
      return postRequest(`/notification_count`, { ...data });
    },
    onSuccess: (success) => {
      if (!success?.status) {
        toaster.error(success?.message);
      }
    },
    onError: () => {
      toaster.error("Something went wrong");
    },
  });
};

export const useLike = () => {
  const toaster = useCustomToaster();
  return useMutation({
    mutationFn: (data) => {
      return postRequest(`/like_news`, { ...data });
    },
    onSuccess: (success) => {
      if (!success?.status) {
        toaster.error(success?.message);
      }
    },
    onError: () => {
      toaster.error("Something went wrong");
    },
  });
};


export const useDeleteNotifications = () => {
  const toaster = useCustomToaster();
  return useMutation({
    mutationFn: (data) => {
      return postRequest(`/clear_notification`, data);
    },
    onSuccess: (success) => {
      if (!success?.status) {
        toaster.error(success?.message);
      }
    },
    onError: () => {
      toaster.error("Something went wrong");
    },
  });
};

export const useMarkNotificationsRead = () => {
  const toaster = useCustomToaster();
  return useMutation({
    mutationFn: (data) => {
      return postRequest(`/profile_update`, data);
    },
    onSuccess: (success) => {
      if (!success?.status) {
        toaster.error(success?.message);
      }
    },
    onError: () => {
      toaster.error("Something went wrong");
    },
  });
};

export const useDeleteAllNotifications = () => {
  const toaster = useCustomToaster();
  return useMutation({
    mutationFn: (data) => {
      return postRequest(`/clear_all_notifications`, data);
    },
    onSuccess: (success) => {
      if (!success?.status) {
        toaster.error(success?.message);
      }
    },
    onError: () => {
      toaster.error("Something went wrong");
    },
  });
};




export const useReadNotification = () => {
  const toaster = useCustomToaster();
  return useMutation({
    mutationFn: (data) => {
      return postRequest(`/read_notification`, data);
    },
    onSuccess: (success) => {
      if (!success?.status) {
        toaster.error(success?.message);
      }
    },
    onError: () => {
      toaster.error("Something went wrong");
    },
  });
};



export const useGetSingleCommunity = () => {
  const toaster = useCustomToaster();
  return useMutation({
    mutationKey: ["get_single_community"],
    mutationFn: (data) => {
      return postRequest(`/get_single_community`, { ...data });
    },
    onSuccess: (success) => {
      if (!success?.status) {
        toaster.error(success?.message);
      }
    },
    onError: () => {
      toaster.error("Something went wrong");
    },
  });
};


//Bank

export const useBankCoummunity = () => {
  const toaster = useCustomToaster();
  return useMutation({
    mutationKey: ["add_bank_account"],
    mutationFn: (data) => {
      return postRequest(`/add_bank_account`, { ...data });
    },
    onSuccess: (success) => {
      if (!success?.status) {
        toaster.error(success?.message);
      }
    },
    onError: () => {
      toaster.error("Something went wrong");
    },
  });
};



export const useGetBankDeatils = () => {
  return useQuery({
    queryKey: ["my_bank_accounts"],
    queryFn: () => {
      return getRequest(`/my_bank_accounts`);
    },
  });
};


export const useDeleteBank = () => {
  const toaster = useCustomToaster();
  return useMutation({
    mutationKey: ["my_bank_accounts"],
    mutationFn: (data) => {
      return postRequest(`/delete_bank_account`, { ...data });
    },
    onSuccess: (success) => {
      if (!success?.status) {
        toaster.error(success?.message);
      }
    },
    onError: () => {
      toaster.error("Something went wrong");
    },
  });
};

export const useEdit = () => {
  const toaster = useCustomToaster();
  return useMutation({
    mutationKey: ["my_bank_accounts"],
    mutationFn: (data) => {
      return postRequest(`/edit_bank_account`, { ...data });
    },
    onSuccess: (success) => {
      if (!success?.status) {
        toaster.error(success?.message);
      }
    },
    onError: () => {
      toaster.error("Something went wrong");
    },
  });
};

export const useUserAccountDelete = () => {
  const toaster = useCustomToaster();
  return useMutation({
    mutationFn: (data) => {
      return postRequest(`/delete_account`, { ...data });
    },
    onSuccess: (success) => {
      if (!success?.status) {
        toaster.error(success?.message);
      }
    },
    onError: () => {
      toaster.error("Something went wrong");
    },
  });
}

export const useFeedBack = () => {
  const toaster = useCustomToaster();
  return useMutation({
    mutationFn: (data) => {
      return postRequest(`/submit_feedback`, { ...data });
    },
    onSuccess: (success) => {
      if (!success?.status) {
        toaster.error(success?.message);
      }
    },
    onError: () => {
      toaster.error("Something went wrong");
    },
  });
};





export const useGetSigCommunity = (post_id) => {
  return useQuery({
    queryKey: ["share_community_post", post_id],
    queryFn: () => {
      return getRequest(`/share_community_post?post_id=${post_id}`);
    },
  });
};